class ErrorBag {
    constructor () {
        this.items = {};
    }
    add (page, error) {
        if (!this.items[page]) {
            Vue.set(this.items, page, [])
        }
        Vue.set(this.items[page], this.items[page].length, error)
    }
    remove (page, index) {
        let modelName = this.items[page].modelName
        let rule = this.items[page].rule
        Vue.delete(this.items[page], index)
        // 重新整理index
        for (let error of this.items[page]) {
    	    if (error.modelName === modelName && error.modelName.rule === rule && error.index > index) {
    	        error.index --;
    	    }
    	}
    }
    removeAll (page, modelName, rule = null, key = null) {
        let index = this.search(page, modelName, rule, key)
        while (index !== -1) {
            this.remove(page, index)
            index = this.search(page, modelName, rule, key)
        }
    }
    search (page, modelName, rule = null, key = null) {
        if (this.items[page]) {
            for (let i = 0; i < this.items[page].length; i ++) {
                if (rule && this.items[page][i].rule !== rule) {
                    continue
                }
                if (key !== null && this.items[page][i].key !== key) {
                    continue
                }
                if (this.items[page][i].modelName === modelName) {
                    return i
                }
            }
        }

        return -1
    }
    has (page, modelName, rule = null, key = null) {
        const index = this.search(page, modelName, rule, key)
        if (index >= 0 && this.items[page][index].showError) {
            return true
        }
        return false
    }
    showAllError (page) {
        for (let i = 0; i < this.items[page].length; i++) {
            //Vue.set(this.items[i], 'showError', true)
            this.items[page][i].showError = true;
        }
    }
}

const checkFuncs = {
    required: (value) => {
        return ~[null, undefined, ''].indexOf(value)
    },
    mobile: (value) => {
        return !(/^1\d{10}$/.test(value))
    },
    tel: (value) => {
        return !(/^[0-9-]{10,15}$/.test(value))
    },
    integer: (value) => {
        const number = Number(value)
        return !((number%1 === 0 && number > 0) || value === '')
    },
    forbidden: (value, forbiddenList) => {
        if (!forbiddenList || !(forbiddenList.length > 0)) return false
        for (let forbidden of forbiddenList) {
            if (value === forbidden) {
                return true
            }
        }
        return false
    }
}

function _validate (page, value, modelName, rule, showError, errorBag, key = 0, forbiddenList = []) {
    const rules = rule.split('|')
    for (let i = 0; i < rules.length; i++) {
        const index = errorBag.search(page, modelName, rules[i], key);

        let checkErr = false
        if (rules[i] === 'forbidden') {
            if (forbiddenList.length <= 0) {
                return
            }
            checkErr = checkFuncs[rules[i]](value, forbiddenList)
        } else {
            checkErr = (checkFuncs[rules[i]] && checkFuncs[rules[i]](value))
        }
        if (checkErr) {
            if (index === -1) {
                errorBag.add(page, {
                    key,
                    modelName,
                    showError,
                    rule: rules[i]
                })
            } else {
                errorBag.items[page][index].showError = showError;
            }
            break;
        } else {
            if (index >= 0) {
                errorBag.remove(page, index)
            }
        }
    }
}

var main = {
    ErrorBag
}

const warn = (message) => {
    console.warn(`[vee-validate] ${message}`); // eslint-disable-line
};

let Vue;
main.install = function(_Vue, options) {
    if (Vue) {
        warn('already installed, Vue.use(VeeValidate) should only be called once.');
        return;
    }

    Vue = _Vue

    const myErrors = new ErrorBag();

    Vue.mixin({
        beforeCreate: function () {

            if (! this.$options.computed) {
                this.$options.computed = {};
            }

            Vue.util.defineReactive(this, 'validateErrors', myErrors);

            this.$options.computed['validateErrors'] = function errorBagGetter () {
                return myErrors
            }
        }
    });
    Vue.directive('va',{
        bind: function(el, binding, vnode){
            if (binding.value) {
                const key = (vnode.data.attrs && vnode.data.attrs['data-key']) || 0
                const page = binding.rawName.replace('v-va.', '')
                const forbiddenList = vnode.data.attrs.forbiddenList || []
                // bind的时候就将不符合的全加入bag，但是不显示报错
                // 如果是普通的input或者是西瓜ui的input
                if (el.tagName !== 'INPUT' && el.className.indexOf('el-input') !== -1) {
                    let inputEL = el
                    if (el.className.indexOf('el-input') !== -1) {
                        inputEL = el.getElementsByTagName('input')[0]
                    }
                    inputEL.addEventListener('blur', function () {
                        _validate(page, inputEL.value, vnode.data.model.expression, binding.value, true, myErrors, key, forbiddenList)
                    })
                    inputEL.addEventListener('blur', function () {
                        _validate(page, inputEL.value, vnode.data.model.expression, binding.value, true, myErrors, key, forbiddenList)
                    })
                    _validate(page, inputEL.value, vnode.data.model.expression, binding.value, false, myErrors, key, forbiddenList)
                } else {
                    const value = (vnode.data.domProps &&vnode.data.domProps.value) || (vnode.data.model && vnode.data.model.value) || '';
                    _validate(page, value, vnode.data.model.expression, binding.value, false, myErrors, key, forbiddenList)
                }
            }
        },
        update: function (el, binding, vnode, oldVnode) {
            // update的时候如果还有错，就显示出来
            // 用model来判断值，比较方便
            // 当model有变化
            const forbiddenList = vnode.data.attrs.forbiddenList || []
            const newValue = (vnode.data.domProps &&vnode.data.domProps.value) || (vnode.data.model && vnode.data.model.value) || ''
            const oldValue = (oldVnode.data.domProps && oldVnode.data.domProps.value) || (oldVnode.data.model && oldVnode.data.model.value) || '';

            if (newValue !== oldValue) {
                let key = (vnode.data.attrs && vnode.data.attrs['data-key']) || 0
                const page = binding.rawName.replace('v-va.', '')
                _validate(page, newValue, vnode.data.model.expression, binding.value, true, myErrors, key, forbiddenList)
            }
        },
        unbind: function (el, binding, vnode) {
            let key = (vnode.data.attrs && vnode.data.attrs['data-key']) || 0
            const page = binding.rawName.replace('v-va.', '')
            myErrors.removeAll(page,vnode.data.model.expression, null, key)
        }
    })
}

export default main



// WEBPACK FOOTER //
// ./src/components/validate/myValidate.js